import { render, staticRenderFns } from "./IndagineEpidemiologicaModelliList.vue?vue&type=template&id=c3b4c096"
import script from "./IndagineEpidemiologicaModelliList.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaModelliList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports